
<div id="dragable" ref="draggable"  class="tbl tbl_col scrollx_tbl_md" style="margin-top:3%">
       <div class="input_group">
       <label class="input_tit">설문조사</label>
       </div> 
        <draggable v-model="list" ghost-class="ghost" @click="onClickDrag($event)" >
            <transition-group>
              <div v-for="(item, index) in list" v-bind:key="index" style="float: left; width:900px;" @change="onChangeDrag($event)">
                        <div class="td_input" style="float: left; width:20%;">
                            <div class="select_form wd_p100">
                                <label class="select_common">{{item.name}}</label>
                                <select class="select_custom" v-model="item.code" @change="fnOnChangeTextAndValue(index, $event.target.value)">
                                    <option v-for="(items, idx) in listCodes" :value="items.code" v-bind:key="idx">{{items.name}}</option>
                                </select>
                            </div>
                        </div>
                        <div style="width: 31%; float:left; margin-top: 10px; font-size: 9px;">
                            <div style="width: 98%">
                                <input type="text" class="form_style wd_p100"  v-model="item.text" tabindex="600">
                            </div>
                        </div>
                         <div style="float:left; width:37%; margin-top: 10px; font-size: 9px;">
                            <div style="width: 98%">
                               <input type="text" class="form_style wd_p100" v-model="item.value" :disabled="item.code != 'MEANVSURNV00200'" tabindex="600">
                            </div>
                        </div> 
                        
                        <div  style="float:left; width:5%; margin-top: 10px;">
                            <a class="btn_item item_del wd_35 dp_inline cursor" @click="fnOnClickRemoveAccodion($event, index);" tabindex="600" @keydown.enter="fnOnClickRemoveAccodion($event, index);">삭제</a>
                        </div>
                 </div>
          </transition-group>
        </draggable>
        <div style="float:right; margin:0 1% 3%" v-if="isExpinfo">
             <a class="btn btn_sm btn_orange cursor" @click="fnOnClickAddAccodion($event, list.length + 1);"  tabindex="600" @keydown.enter="fnOnClickAddAccodion($event, list.length + 1);">추가</a>
        </div>
         <div style="float:right; margin:0 1% 3%" v-if="!isExpinfo">
             <a class="btn btn_sm btn_purple cursor" @click="fnOnClickAddAccodion($event, list.length + 1);"  tabindex="600" @keydown.enter="fnOnClickAddAccodion($event, list.length + 1);">추가</a>
        </div>
</div>
